import React from 'react';
import LoginForm from './common/LoginForm';
import { connect } from "react-redux";

import imgCity from './imgs/city.jpg';
import imgLogo from './imgs/login-logo.png';
import { browserHistory as history } from 'react-router';
import _ from 'lodash';
import StaffReporting from './StaffReporting';
import ROUTE from "../constants/routes";

export class Home extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var user = this.props.auth.user;
        if (user) {
            if (user.accountType == 'staff') {
                history.push('/info-list');
                return;
            }
            if (user.accountType == 'central-user') {
                history.push('/assign-to-closer');
                return;
            }
            if (user.accountType == 'closer') {
                history.push('/lead');
                return;
            }
            if(user.accountType == 'vendor') {
                history.push(ROUTE.ASSIGNED_VENDOR);
                return;
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.auth.user && !this.props.auth.user) {
            var user = newProps.auth.user;
            if (user) {
                if (user.accountType == 'staff') {
                    history.push('/info-list');
                    return;
                }
                if (user.accountType == 'central-user') {
                    history.push('/assign-to-closer');
                    return;
                }
                if (user.accountType == 'closer') {
                    history.push('/lead');
                    return;
                }
                if(user.accountType == 'vendor') {
                    history.push(ROUTE.ASSIGNED_VENDOR);
                    return;
                }
            }
        }
    }


    render() {
        if (!this.props.auth.user) {
            return (
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-u-md8 p0">
                            <img className="vh100 w100p object-fit-cover" src={imgCity} />
                        </div>
                        <div className="ms-Grid-col ms-u-md4 p0">
                            <div className="p20">
                                <div className="p20">
                                    <img className="w100p" src={imgLogo} />
                                </div>
                                <LoginForm />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        return <div style={{ paddingTop: 20 }}>
            <StaffReporting isDisplayChart={true} isDisplayTable={false} />
        </div>
    }

    widthChart() {
        try {
            var data = this.state.data;
            var v = data.length / 10;
            v = v > 1 ? v : 1;
            return Math.round(window.innerWidth * v);
        }
        catch (ex) {
            return 1000;
        }
    }

    heightChart() {
        try {
            return window.innerHeight - 100;
        }
        catch (ex) {
            return 600;
        }
    }

    YValue() {

    }
}


function mapStateToProps(state, own_props) {
    return {
        auth: state.auth
    }
}
export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./client/components/Home.js